export const JAMO_L_TABLE = [
	"G",
	"GG",
	"N",
	"D",
	"DD",
	"R",
	"M",
	"B",
	"BB",
	"S",
	"SS",
	"",
	"J",
	"JJ",
	"C",
	"K",
	"T",
	"P",
	"H",
]

export const JAMO_V_TABLE = [
	"A",
	"AE",
	"YA",
	"YAE",
	"EO",
	"E",
	"YEO",
	"YE",
	"O",
	"WA",
	"WAE",
	"OE",
	"YO",
	"U",
	"WEO",
	"WE",
	"WI",
	"YU",
	"EU",
	"YI",
	"I",
]

export const JAMO_T_TABLE = [
	"",
	"G",
	"GG",
	"GS",
	"N",
	"NJ",
	"NH",
	"D",
	"L",
	"LG",
	"LM",
	"LB",
	"LS",
	"LT",
	"LP",
	"LH",
	"M",
	"B",
	"BS",
	"S",
	"SS",
	"NG",
	"J",
	"C",
	"K",
	"T",
	"P",
	"H",
]
